import React from "react";
import ReactPlayer from 'react-player'
import windowDimensions from "../utility/windowDimensions";
import "../CSS/player.css"
import youtubeImg from "../assets/youtube.webp";

export default function Player() {
  const { width } = windowDimensions();
    return (
      <div className="player-wrapper">
        <ReactPlayer
          width="100%"
          height={width < 500 ? "35vh" : "90vh"}
          className="react-player"
          url="https://www.youtube.com/watch?v=T0R7g9oFhlk"
          light={youtubeImg}
          style={{background: "black"}}
          controls={true}
        />
      </div>
    );
  }